import { BindKey, ClassOptions, ClassValue, PumpIt, SCOPE } from 'pumpit';
//import { AvailableScopes, BindKey, ClassOptions, ClassValue } from 'pumpit/dist/types/types';

const container = new PumpIt();

type InjectableTypes = (abstract new (...args: any[]) => any)[];
interface InjectableOptions<T> {
    value: new (...args: any[]) => T;
    inject: InjectableTypes;
}

export function MakeInjectable<T>(key: new (...args: any[]) => T, options: InjectableOptions<T> | InjectableTypes) {
    if (Array.isArray(options)) {
        _MakeInjectable(key, { value: key, inject: options });
    }
    else {
        _MakeInjectable(key, options);
    }
}

function _MakeInjectable<T extends ClassValue>(key: BindKey, value: T, options?: Omit<Partial<ClassOptions>, 'type'>) {
    container.bindClass(key, value, { scope: SCOPE.SINGLETON });
}

export function RegisterInstanceType<T>(key: new (...args: any[]) => T, options: InjectableOptions<T> | InjectableTypes) {
    if (Array.isArray(options)) {
        _RegisterInstanceType(key, { value: key, inject: options });
    }
    else {
        _RegisterInstanceType(key, options);
    }
}

function _RegisterInstanceType<T extends ClassValue>(key: BindKey, value: T, options?: Omit<Partial<ClassOptions>, 'type'>) {
    container.bindClass(key, value, { scope: SCOPE.TRANSIENT });
}

export function useService<T>(serviceType: abstract new (...args: any[]) => T): T {
    return container.resolve(serviceType);
}

// equivalent of useService but for classes
export function GetService<T>(serviceType: abstract new (...args: any[]) => T): T {
    return container.resolve(serviceType);
}
export function GetServiceInterface<T>(serviceType: { prototype: T }): T {
    return container.resolve(serviceType);
}

export function CreateInstance<T>(serviceType: new (...args: any[]) => T): T {
    return container.resolve(serviceType);
}